/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { config, SETTING_KEY } from '../../config/Config';
toast.configure();

const WhatsAppPhone = ({ whatsAppPhone, setWhatsAppPhone }) => {
  const { t } = useTranslation();

  const getSetting = async () => {
    const resp = await axios.get(config.API_URL.SETTING.GET, {
      params: {
        key: SETTING_KEY.WHATSAPP,
      },
      headers: config.headers,
    });
    const { data } = resp;
    const { setting } = data;
    setWhatsAppPhone({
      value: setting.value || 0,
    });
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handlerChange = (e) => {
    const newValue = {
      ...whatsAppPhone,
      [e.target.name]: e.target.value,
    };
    setWhatsAppPhone(newValue);
  };

  return (
    <div className="setting">
      <h3>{t('whatsapp_phone')}</h3>
      <div className="row flex items-center gap-x-4">
        <label>{t('whatsapp_phone')}: </label>
        <input type="text" value={whatsAppPhone.value} name="value" onChange={handlerChange} />
      </div>
    </div>
  );
};
export default WhatsAppPhone;
